module.exports = "/static-assets/_next/static/images/snowflakes-small-55f72e675308890ef0df1df62fbe63d6.png";